import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { VueReCaptcha } from 'vue-recaptcha-v3'
import './plugins/base'

// import Default from '@/layout/wrappers/baseLayout.vue'

Vue.config.productionTip = false

Vue.use(VueReCaptcha, {
  siteKey:'6LesXK4ZAAAAAN8wzzIXMTTjjt0-iZhnROb90Y0A',
  badge:'inline',
  loaderOptions: {
    badge:'bottomleft',
    useRecaptchaNet: true,    
  }
})


// Vue.component('default-layout', Default);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
